import { render } from "./Notes6.vue?vue&type=template&id=356060de&scoped=true"
import script from "./Notes6.vue?vue&type=script&lang=js"
export * from "./Notes6.vue?vue&type=script&lang=js"

import "./Notes6.vue?vue&type=style&index=0&id=356060de&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-356060de"]])

export default __exports__